import * as Domain from './domain';

export const quizPlayerModules = [
  Domain.quizPlayerDomainModule
]
